import { render, staticRenderFns } from "./TheNavbarMenu.vue?vue&type=template&id=4ce7bdd8&"
import script from "./TheNavbarMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheNavbarMenu.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports